module.exports = __webpack_public_path__ + "static/media/bg-purple.0ccc8ae9.svg";